import { Form, Field, FormElement, FieldWrapper, FieldRenderProps, FormRenderProps } from '@progress/kendo-react-form';
import { Label, Error, Hint, FloatingLabel } from '@progress/kendo-react-labels';
import { Input } from '@progress/kendo-react-inputs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faInfoCircle,faQuestionCircle, faTrash} from '@fortawesome/free-solid-svg-icons';
import { docLinks } from './Configuration';
import { DocLinks,ColTypeEntry, NewSize } from '../services/interfaces';
import { ColTypeList } from './FormComponents';
import { useContext, useEffect, useState } from 'react';
import { SubmissionContext } from './SubmissionFormContext';
import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { getColTypeList,getModSizeList, getPackageData } from '../services/apiService';
import { CompositeFilterDescriptor, filterBy } from '@progress/kendo-data-query';
import { InputChangeEvent } from '@progress/kendo-react-inputs';
import { Button } from 'reactstrap';
import { Grid, GridCellProps, GridColumn } from '@progress/kendo-react-grid';

function SizeForm(){
    const [colType, setColType] = useState<ColTypeEntry>()
    const [modSizeList, setModSizeList] = useState<ColTypeEntry[]>();
    const [sizeSelected, setSizeSelected]=useState<any>();
    const [newSizes, setNewSizes]=useState<NewSize[]>([]);
    const [showModList, setShowModList] = useState(false);
    const subContext = useContext(SubmissionContext);

    const setSubmitColType=(colType:ColTypeEntry[])=>{
        console.log("Set type: ");
        console.log(colType);
        subContext?.setSubmitForm(prevObject => ({ ...prevObject, category: colType[0] }));
        setColType(colType[0]);
    } 

   

    const setSubmitSize=(size:DropDownListChangeEvent)=>{
        console.log(size.value);
        setSizeSelected(size.value);
        if(subContext?.submitForm.subType!="SP"){
            //only one size so set it here
            subContext?.setSubmitForm(prevObject=>({...prevObject,size:[size.value]}));
        }
        checkState();
    }

    
    const setSubmitSizeSingle=(event: InputChangeEvent)=>{
        if (subContext?.submitForm.subType!="SP"){
            setSizeSelected(event.value);
            subContext?.setSubmitForm(prevObject=>({...prevObject, size: event.value ? [event.value] : [""]}));
            checkState();
        }else{
            setSizeSelected(event.value);
            console.log("Spec Ad. Do nothing")
        }
    }

    const getModSizes=()=>{
        if (subContext && subContext.submitForm.category.type=="M"){
            getModSizeList(subContext?.submitForm.site.code,subContext.submitForm.category.category).then(data=>{
                console.log(data);
                setModSizeList(data);
            })
        }
    }

    const addSize=()=>{
        const type=colType?.category||"";
        var size;
        var strIn;
        if (colType?.type!=undefined){
            if (colType?.type=="M"){
                if (sizeSelected.size!=""){
                    size=sizeSelected.size;
                    strIn=sizeSelected.strIn;
                }
            }else{
                if (sizeSelected){
                    size=sizeSelected;
                    strIn=sizeSelected;
                }
            }
            const newSize:NewSize={
                type:type,
                size:size,
                strIn:strIn
            }
            console.log(newSize);
            if (newSize.size){
                subContext?.setSubmitForm(prevObject=>({
                    ...prevObject,
                    size:[...subContext.submitForm.size, newSize] // Ensure only strings are added to the size array
                }))
                setFormValid(true);
            }else{
                setFormValid(false);
            }
        }else{
            setFormValid(false);
        }
        //setNewSizes([...newSizes, newSize]);

    }
    const validateSize=()=>{
        if (validColType() && validSize()){
            setFormValid(true);
        }else{
            setFormValid(false);
        }
    }

    const setFormValid=(val:boolean)=>{
        const subValid = subContext?.submitValid;
        if (subValid) {
            subValid.sizes = val;
            if (subContext) {
                subContext.submitValid = subValid;
            }
        }
    }

    const checkState=()=>{
        const isValid = validateSize();
        console.log(subContext?.submitForm);
    }

    const validColType=()=>{
        if (subContext?.submitForm.subType!=="SP"){
            if (subContext?.submitForm.category.category){
                return (true);
            }else{
                return(false);
            }
        }else{
            if (subContext.submitForm.size.length>0){
                return (true);
            }else{
                return (false);
            }
        }
    }

    const validSize = ()=>{        
        if ((subContext?.submitForm.size ?? []).length > 0){
            return (true);
        }else{
            return(false);
        }
    }

    const getSize=()=>{
        if (subContext?.submitForm.subType!=="SP"){
            if ((subContext?.submitForm.size ?? []).length > 0){
                console.log(subContext?.submitForm.size);
                const retVal=subContext?.submitForm.size[0];
                return (subContext?.submitForm.size[0])
            }else{
                return "";
            }
        }else{
            return"";
        }

    }

    const deleteSize=(dataItem:{type:string, size:string,strIn:string})=>{
        let adArray = subContext?.submitForm.size;
        let newArray:NewSize[] = []
        if (adArray){
            adArray.forEach(size => {
                if (size.type===dataItem.type && size.size ===dataItem.size){
                    //this is the entry being deleted
                }else{
                    newArray.push(size);
                }
            });
            if (newArray.length===0){
                subContext?.setSubmitForm(prevObject=>({
                ...prevObject,
                size:[]}))
                setFormValid(false);
            }else{
                subContext?.setSubmitForm(prevObject=>({
                    ...prevObject,
                    size:newArray // Ensure only strings are added to the size array
                }))
                setFormValid(true);
            }
        }
    }


    const deleteButton = (props: GridCellProps) => {
        return (subContext?.submitForm.size?.length ?? 0) > 0 ? (
            <td>
                <Button fillMode={"flat"} onClick={() => deleteSize(props.dataItem)}>
                    <FontAwesomeIcon icon={faTrash}></FontAwesomeIcon>
                </Button>
            </td>
        ) : null;
    }

    useEffect(()=>{
        console.log(colType);
        if (colType) {
            subContext?.setSubmitForm(prevObject => ({ ...prevObject, category: colType }));
        }else{
            if (subContext?.submitForm.category){
                setColType(subContext.submitForm.category);
            }
        }
        if (colType?.type=="M"){
            setShowModList(true);
            getModSizes();
        }else{
            setShowModList(false);
        }
    },[colType])

    useEffect(()=>{
        if (colType?.type=="M"){
            setShowModList(true);
            getModSizes();
        }else{
            setShowModList(false);
        }
    },[subContext?.submitForm.category])

    useEffect(()=>{
        checkState();
    },[sizeSelected])


    useEffect(()=>{
        var size:{size:string, strIn:string,strOut:string,modId:string,siteCode:string}|string;
        if (Array.isArray(subContext?.submitForm.size) && subContext.submitForm.size.length>0){
            size=subContext?.submitForm.size[0] as {size:string, strIn:string,strOut:string,modId:string,siteCode:string};
        }else{
            size=(subContext?.submitForm.size ?? {}) as {size:string, strIn:string,strOut:string,modId:string,siteCode:string};
        }
        var newSize="";
        if(typeof size==='string'){
            newSize=size;
        }else{
            newSize=size.size;
        }    
        var site = subContext?.submitForm.site;
        if (newSize){
            getPackageData(site?.code,newSize).then(fetchedData => {
                console.log(fetchedData);
                subContext?.setPkgData(fetchedData);
            });
        }
    },[subContext?.submitForm.size])

    return(
        <div>
            <h5>AD SIZE INFORMATION</h5>
            <FieldWrapper>
                <Label>Type:</Label>
                <ColTypeList setReturnAction={setSubmitColType} value={[subContext?.submitForm.category || {category: '', type: '',display:'',site:'',specView:''}]} multi={false} valid={validColType()} site={subContext?.submitForm.site || { code:"",name:"",logo_Prefix:"",primary_ip:"",backup_ip:"",temp_Char:"",temp_Int:"",vol1_Unc_Path:"",vol2_Unc_Path:""}} adType={subContext?.submitForm.adType.value||""}/>
            </FieldWrapper>
            <FieldWrapper>
                <Label>Size:</Label>
                {showModList?
                <DropDownList
                    data={modSizeList}
                    textField='size'
                    dataItemKey='strIn'
                    fillMode={"outline"}
                    onChange={setSubmitSize}
                    value={subContext?.submitForm.subType!=="SP"?subContext?.submitForm.size[0]:sizeSelected}
                />
                :<Input onChange={setSubmitSizeSingle} value={subContext?.submitForm.subType!=="SP"?subContext?.submitForm.size[0]:sizeSelected} valid={validSize()} disabled={false} />}
                {subContext?.submitForm.subType=="SP"?
                    <FieldWrapper>
                        <Button className='mb-3' onClick={addSize}>Add Size</Button>
                        <Grid 
                            data={subContext.submitForm.size}
                        >
                             <GridColumn
                                width={60}
                                field='element'
                                title='&nbsp;'
                                cells={{data:deleteButton}}
                            />
                            <GridColumn title='Type' field='type'/>
                            <GridColumn title='Size' field='size'/>
                            <GridColumn title='Value' field='strIn'/>
                        </Grid>
                    </FieldWrapper>:null
                }
            </FieldWrapper>       
        </div>
    )
}


export const SubmitSizes =(
    <SizeForm/>
)